import { Route } from '@angular/router';
import { FeatureExplainComponent } from './domains/explainer';
import { UiMainLayoutComponent } from './shared/ui-main-layout';
import { FeatureLoginComponent } from './auth/feature-login/feature-login.component';
import { FeatureSurveyComponent } from './domains/survey/feature-survey/feature-survey.component';
import { FeatureSignUpComponent } from './auth/feature-sign-up/feature-sign-up.component';
import { FeatureForgotCodeComponent } from './auth/feature-forgot-code/feature-forgot-code.component';
import { AuthGuard } from './auth/data/auth.guard.service';
import { FeatureAvailableSurveysComponent } from './domains/available-surveys/feature-available-surveys.component';
import { FeatureStatsComponent } from './domains/stats/feature-stats/feature-stats.component';
import { FeatureSettingsComponent } from './domains/settings/feature-settings/feature-settings.component';
import { FeatureOnDemandComponent } from './domains/on-demand/feature-on-demand.component';
import { FeatureAccountComponent } from './domains/account/feature-account.component';
import { SurveyInterventionComponent } from './domains/survey/feature-survey/survey-intervention/survey-intervention.component';
import { FeatureNotFoundComponent } from './shared/feature-not-found/feature-not-found.component';
import { FeatureUnsubscribeComponent } from './domains/settings/feature-unsubscribe/feature-unsubscribe.component';
import { FeatureBookingComponent } from './domains/booking/feature-booking/feature-booking.component';
import {
  FeatureEmailChangeVerificationComponent
} from './domains/verification/feature-email-change-verification/feature-email-change-verification.component';
import { FeatureSsoRedirectComponent } from './auth/feature-sso-redirect/feature-sso-redirect.component';
import { FeatureSignUpDemoComponent } from './auth/feature-sign-up-demo/feature-sign-up-demo.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: UiMainLayoutComponent,
    children: [
      {
        path: '',
        component: FeatureAvailableSurveysComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'forgot/:token',
        component: FeatureForgotCodeComponent
      },
      {
        path: 'signup/:token',
        component: FeatureSignUpComponent
      },
      {
        path: 'signup-demo',
        component: FeatureSignUpDemoComponent
      },
      {
        path: 'login',
        component: FeatureLoginComponent
      },
      {
        path: 'login/:token',
        component: FeatureLoginComponent
      },
      {
        path: 'available-surveys',
        component: FeatureAvailableSurveysComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'explain',
        component: FeatureExplainComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'survey',
        component: FeatureSurveyComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'survey',
        component: FeatureSurveyComponent,
        children: [
          {
            path: '',
            component: FeatureSurveyComponent,
            data: { onDemand: true, type: 'who5' }
          }
        ]
      },
      {
        path: 'survey-intervention/:type',
        component: SurveyInterventionComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'stats',
        component: FeatureStatsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'settings',
        component: FeatureSettingsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'on-demand',
        component: FeatureOnDemandComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: FeatureOnDemandComponent,
            data: { type: 'mind' }
          }
        ]
      },
      {
        path: 'account',
        component: FeatureAccountComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'unsubscribe/:token',
        component: FeatureUnsubscribeComponent,
      },
      {
        path: 'Unsubscribe/:token',
        component: FeatureUnsubscribeComponent,
      },
      {
        path: 'web/unsubscribe',
        component: FeatureUnsubscribeComponent,
      },
      {
        path: 'Web/Unsubscribe',
        component: FeatureUnsubscribeComponent,
      },
      {
        path: 'Web/ManagerUnsubscribe',
        component: FeatureUnsubscribeComponent,
      },
      {
        path: 'manager-unsubscribe/:token',
        component: FeatureUnsubscribeComponent,
      },
      {
        path: 'booking/:token',
        component: FeatureBookingComponent,
      },
      {
        path: 'Booking/:token',
        component: FeatureBookingComponent,
      },
      {
        path: 'confirm-email-change/:token',
        component: FeatureEmailChangeVerificationComponent,
      },
      {
        path: 'Web/Sso',
        component: FeatureSsoRedirectComponent
      },
      {
        path: 'web/sso',
        component: FeatureSsoRedirectComponent
      },
      {
        path: '**',
        component: FeatureNotFoundComponent,
      }
    ]
  }
];
